/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export default function MultiSelect(props) {
    const serverURL = process.env.REACT_APP_SERVER_URL;
    const [amenities, setAmenities] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    // Fetch amenities from API
    const getAmenities = async () => {
        try {
            const res = await toast.promise(
                axios.get(`${serverURL}/api/amenities`),
                {
                    loading: "Fetching...",
                    success: "Data fetched successfully",
                    error: "Couldn't fetch the data"
                }
            );
            const { data } = res.data;
            setAmenities(data);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    // Fetch amenities on mount
    useEffect(() => {
        getAmenities();
    }, []);

    // Convert amenities to react-select options
    useEffect(() => {
        const newOptions = amenities.map(item => ({
            value: item._id,
            label: item.name
        }));
        setOptions(newOptions);
    }, [amenities]);

    // Set default selected values when props.selected or options change
    useEffect(() => {
        if (props.selected && options.length > 0) {
            const matchedOptions = options.filter(opt =>
                props.selected.includes(opt.value)
            );
            setSelectedOptions(matchedOptions);
            setSelectedAmenities(props.selected);
        }
    }, [props.selected, options]);

    // Handle selection change
    const changeHandler = (value) => {
        const ids = value.map(item => item.value);
        setSelectedAmenities(ids);
        setSelectedOptions(value);
    };

    // Notify parent of changes
    useEffect(() => {
        props.onChange(selectedAmenities);
    }, [selectedAmenities]);

    return (
        <div className="form-group" style={{ margin: '1rem 0' }}>
            <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                isMulti
                options={options}
                value={selectedOptions}
                onChange={changeHandler}
            />
        </div>
    );
}
